import { Link } from "react-router-dom";
import { IPlanDetailsOurData } from "../../interfaces/api";
import { useZipRootLoaderData } from "../../hooks/useZipRootLoaderData";

const BackNavDetails = ({ county }: { county: IPlanDetailsOurData[] }) => {
  const { zip } = useZipRootLoaderData();

  const printHandler = () => {
    const list = document.getElementsByClassName("expand-all");

    // @ts-ignore
    for (let item of list) {
      item.click();
    }

    setTimeout(() => {
      // @ts-ignore
      window.print();
    }, 500);
  };

  return (
    <div style={{ backgroundColor: "#F5F9FD" }}>
      <div className="grid-container">
        <div
          style={{
            justifyContent: "space-between",
            padding: "15px 20px ",
            backgroundColor: "#F5F9FD",
          }}
          className="show-for-small-only"
        >
          <Link
            to={{
              pathname: "/all-plans",
            }}
          >
            <div
              style={{
                fontSize: 18,
                fontWeight: 500,
                lineHeight: "120%",
                textDecoration: "underline",
                color: "#1B54C2",
                cursor: "pointer",
                paddingBottom: 22,
              }}
            >
              Back to All Plans
            </div>
          </Link>
          <div style={{ display: "flex", fontSize: 18 }}>
            <div
              style={{
                color: "#212126",
                paddingRight: "10px",
                fontWeight: 500,
              }}
              className="text-uppercase"
            >
              {zip} {county[0].countyName} County, {county[0].countyStateCode}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "15px 20px ",
            backgroundColor: "#F5F9FD",
          }}
          className="hide-for-small-only"
        >
          <Link
            to={{
              pathname: "/all-plans",
            }}
          >
            <div
              style={{
                fontSize: 18,
                fontWeight: 500,
                lineHeight: "120%",
                textDecoration: "underline",
                color: "#1B54C2",
                cursor: "pointer",
              }}
            >
              Back to All Plans
            </div>
          </Link>
          <div style={{ display: "flex", fontSize: 18 }}>
            <div
              style={{
                color: "#212126",
                paddingRight: "10px",
                fontWeight: 500,
              }}
              className="text-uppercase"
            >
              {zip} {county[0].countyName} County, {county[0].countyStateCode}
            </div>
            <div
              onClick={printHandler}
              style={{
                color: "#1B54C2",
                paddingLeft: "10px",
                textDecoration: "underline",
                fontWeight: 500,
                borderLeft: "2px solid #8A8A8A",
                cursor: "pointer",
              }}
            >
              Print
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackNavDetails;
